/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyLitecoin = createReactComponent(
  "currency-litecoin",
  "IconCurrencyLitecoin",
  [
    [
      "path",
      { d: "M18 19h-8.194a2 2 0 0 1 -1.98 -2.283l1.674 -11.717", key: "svg-0" }
    ],
    ["path", { d: "M14 9l-9 4", key: "svg-1" }]
  ]
);

export { IconCurrencyLitecoin as default };
//# sourceMappingURL=IconCurrencyLitecoin.js.map
